/**
 * Which failed calls the client answers with one refresh-and-retry. Kept free of oRPC and the DOM so it is
 * unit-tested on its own.
 */

/** Calls whose 401 means "wrong credentials", not "expired access token" — never refreshed. */
const NEVER_REFRESHED: readonly string[] = ['auth.login', 'auth.refresh', 'auth.logout'];

export const procedureName = (path: readonly string[]): string => path.join('.');

export const shouldRefreshAfter = (path: readonly string[], status: number | undefined, hasRefreshToken: boolean): boolean =>
  status === 401 && hasRefreshToken && !NEVER_REFRESHED.includes(procedureName(path));

/**
 * Runs `refresh` once for any number of concurrent callers: ten queries that 401 together share one refresh,
 * which matters because a refresh token is single-use.
 */
export const createSingleFlight = <TResult>(run: () => Promise<TResult>): (() => Promise<TResult>) => {
  let inFlight: Promise<TResult> | null = null;

  return () => {
    inFlight ??= run().finally(() => {
      inFlight = null;
    });

    return inFlight;
  };
};
